export default __webpack_public_path__ + "static/media/header-xl-2x.77c4175d.webp";